import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import { i18nManager } from '@/utils/i18n'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    currentLanguage: localStorage.getItem('language') || 'zh-TW'
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    SET_LANGUAGE(state, language) {
        state.currentLanguage = language
        localStorage.setItem('language', language)
        i18nManager.setLanguage(language)
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js